export default {
    a1:'enA1'
}